
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _404_45vmK9oPvJxZPMSX6RP6mhABN0H_45cBT3CK_bldmEau7QMeta } from "/src/pages/404.vue?macro=true";
import { default as _500GFPIofBAuSzOIURgWnQll5fv6M1uBYuIyAOg46gaaVIMeta } from "/src/pages/500.vue?macro=true";
import { default as news58gls2hINhLPCvIAqI0lk3gJG_xEAgAT_45CbkBm9Lm64Meta } from "/src/pages/news.vue?macro=true";
import { default as forms7DDN9_OodCHAnG5kEQrKadf4kCC79cQgji1sW9S8WGEMeta } from "/src/pages/forms.vue?macro=true";
import { default as indexD8Kf5nPoGkO_45mPRcy0kXxYdHgQUU8jSfv0icJqY11_45oMeta } from "/src/pages/index.vue?macro=true";
import { default as awards7GDQV8UOSbkG4WTXNMlsVPakU1IQa90k6DOVbu15jmMMeta } from "/src/pages/awards.vue?macro=true";
import { default as examplek_45RuDDD09KxyLo8i6Mr6HayeIphXOhdotyVkf6clZWoMeta } from "/src/pages/example.vue?macro=true";
import { default as meetingSSpgQPFzofznlNAgHI0x_6_Um_zuhKibXYD_45j_45yiPsAMeta } from "/src/pages/meeting.vue?macro=true";
import { default as recruitRkKQWD_1_KT9Na2uE_45U78_45_cKeTsuW_oyPUb5hkdYgMMeta } from "/src/pages/recruit.vue?macro=true";
import { default as asset_4EOH2ID2MVMsR4Kkah5dgsg7DjtCnARU0O8I78CA54Meta } from "/src/pages/my/asset.vue?macro=true";
import { default as chargebgQqbuw2yDiYAYkq8JmOPGmyRKZNco_Sep9BLr7GnEsMeta } from "/src/pages/my/charge.vue?macro=true";
import { default as _91id_93aVRSqzrJ8byyKSneuolDlsoAaJf2SP7KR_S2D_45RkgkYMeta } from "/src/pages/funds/[id].vue?macro=true";
import { default as clientseaK42iqk2Bcsax68V0gBtRyh4XYUCf1MpbpX7AXSt1EMeta } from "/src/pages/my/clients.vue?macro=true";
import { default as historyanIsx3ejdIDyAYUNOsWSiSPO2OJS4vku_rzW9igNfGEMeta } from "/src/pages/my/history.vue?macro=true";
import { default as indexn2s7p5m3f2IvTsOutjwrZistLUury3_45ZZ55qWn9C9MkMeta } from "/src/pages/admin/index.vue?macro=true";
import { default as indexmG_45tCTh9qbvo0FyKBpvOUf1eaiQd3T4jhnyZLNZzK7QMeta } from "/src/pages/funds/index.vue?macro=true";
import { default as announcementSIHBP945_ayZk6qWTlB_GlLZBw4p08TuoXyuD_45Sh_45roMeta } from "/src/pages/announcement.vue?macro=true";
import { default as chatbot6ov2u8CgHb0VpIEYd7kmVs0D37SUm_45LYLGQvnipx0poMeta } from "/src/pages/demo/chatbot.vue?macro=true";
import { default as _91id_93LTd_7qqot6wE7FMf7EYHD6AsBaO1m9B9qbW7l_45ue6JAMeta } from "/src/pages/comments/[id].vue?macro=true";
import { default as passwdbbtEZossInGMWpGdIbeRRVgNYT1AC8RaH1MibNBQiHUMeta } from "/src/pages/member/passwd.vue?macro=true";
import { default as signin3aa_45AHf19K2hjCT_45Tu00knih7cI5JKQyruPgrc3zjRUMeta } from "/src/pages/member/signin.vue?macro=true";
import { default as signupodiHZdUYeOomueJ30WSChxLvAFpLBNflRo7MqjZZhX8Meta } from "/src/pages/member/signup.vue?macro=true";
import { default as indexM2txBwHfcIeA5g_pWFuvwmiPhs9GUyOP5Hsu3GWc_45OQMeta } from "/src/pages/comments/index.vue?macro=true";
import { default as _2023vipxDbYIFeqjfDpBzRadu1jnwwG6aPQ2urc03O2P0Oq3osMeta } from "/src/pages/events/2023vip.vue?macro=true";
import { default as notify_45_91id_93Y5ibbBzvc_ulAmTyqPgZ8keG_0bMRaS3C6lT1izihdkMeta } from "/src/pages/my/notify-[id].vue?macro=true";
import { default as _91_91type_93_932Nu6NCDyg0eH0Zrx0SO3kWmOuQR_45XiHsceUV3R2xIpUMeta } from "/src/pages/manage/[[type]].vue?macro=true";
import { default as w89BJg17aZQU426C89PtZGhzx3dVoAoeNCDBtjFqStp14Meta } from "/src/pages/admin/accounts/w8.vue?macro=true";
import { default as _91_91tab_93_93mcRZS7sWDY3SHBcFYZumtDVzBaQL5rjZkNauc_45Rj8_wMeta } from "/src/pages/my/notify/[[tab]].vue?macro=true";
import { default as indexpe3SBrJU0yB0xlFjhmF8FuxzRci_45_1i62bT4gSY934IMeta } from "/src/pages/member/forget/index.vue?macro=true";
import { default as _91_91type_93_93z8qQBHy0rnDch_45WzcNAghwGR_lzbOwN1TWBBJ7xuGIYMeta } from "/src/pages/my/dealing/[[type]].vue?macro=true";
import { default as _91_91tab_93_93Cr_fyi9z3oJgsXeSiccJgnY_fW_JAMFdgp6Kn1ZlrHAMeta } from "/src/pages/sub-accounts/[[tab]].vue?macro=true";
import { default as indexqi1oxHE815T7oYwetwpE2d8i2X_451hbUmfD0JN8UVbdsMeta } from "/src/pages/admin/reports/browse/index.vue?macro=true";
import { default as _91_46_46_46slug_93RLv_45WWohblgeIDlpRlTRi0ma_45_KXleRPmEa_ITk5S5MMeta } from "/src/pages/admin/reports/edit/[...slug].vue?macro=true";
import { default as template5_034aQTYOWMdfkAm0pcQZfy1adEIyBr3Lj24xnAc8QMeta } from "/src/pages/internal/fundReport/template.vue?macro=true";
import { default as reference_45dataq7O12cHjyqGd7_45u__tWRmBhIK7V_45MTXJhbsRsHYc_eUMeta } from "/src/pages/admin/accounts/reference-data.vue?macro=true";
import { default as _91_46_46_46slug_93FLVXOJbuplc6FGH960HQ1A4EDKAia4j9nMcooPyQFzQMeta } from "/src/pages/admin/reports/browse/[...slug].vue?macro=true";
import { default as _91_91time_93_93eaVZSXGg4IBNRc1HGQyF9LLLniyxzYEKsMhc2urlmnYMeta } from "/src/pages/admin/reports/limited/[[time]].vue?macro=true";
import { default as templatemg4Y571wVLVDTaFvSuyQRoXhoPeTmj2xIZku3fnFExwMeta } from "/src/pages/internal/rebateReport/template.vue?macro=true";
import { default as _91_46_46_46slug_93AzjGfzcjv_45ALQ868dyo_457gpTAvhc26PQOdzf_459GfI2wMeta } from "/src/pages/admin/reports/preview/[...slug].vue?macro=true";
import { default as _91token_93nixFyM3q4wZeysE6UzE64ziAmLq6ch42mqo5GvXSAH8Meta } from "/src/pages/member/forget/[usercode]/[token].vue?macro=true";
import { default as _91otpCode_93O0mm4pytvql_45DAMAgcI8CsHzEx5ueKJeM3QfLLUvEEAMeta } from "/src/pages/member/otp-signin/[usercode]/[otpCode].vue?macro=true";
export default [
  {
    name: "404___en",
    path: "/en/404",
    component: () => import("/src/pages/404.vue")
  },
  {
    name: "404___zh",
    path: "/zh/404",
    component: () => import("/src/pages/404.vue")
  },
  {
    name: "500___en",
    path: "/en/500",
    component: () => import("/src/pages/500.vue")
  },
  {
    name: "500___zh",
    path: "/zh/500",
    component: () => import("/src/pages/500.vue")
  },
  {
    name: "news___en",
    path: "/en/news",
    meta: news58gls2hINhLPCvIAqI0lk3gJG_xEAgAT_45CbkBm9Lm64Meta || {},
    component: () => import("/src/pages/news.vue")
  },
  {
    name: "news___zh",
    path: "/zh/news",
    meta: news58gls2hINhLPCvIAqI0lk3gJG_xEAgAT_45CbkBm9Lm64Meta || {},
    component: () => import("/src/pages/news.vue")
  },
  {
    name: "forms___en",
    path: "/en/forms",
    meta: forms7DDN9_OodCHAnG5kEQrKadf4kCC79cQgji1sW9S8WGEMeta || {},
    component: () => import("/src/pages/forms.vue")
  },
  {
    name: "forms___zh",
    path: "/zh/forms",
    meta: forms7DDN9_OodCHAnG5kEQrKadf4kCC79cQgji1sW9S8WGEMeta || {},
    component: () => import("/src/pages/forms.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/src/pages/index.vue")
  },
  {
    name: "index___zh",
    path: "/zh",
    component: () => import("/src/pages/index.vue")
  },
  {
    name: "awards___en",
    path: "/en/awards",
    component: () => import("/src/pages/awards.vue")
  },
  {
    name: "awards___zh",
    path: "/zh/awards",
    component: () => import("/src/pages/awards.vue")
  },
  {
    name: "example___en",
    path: "/en/example",
    component: () => import("/src/pages/example.vue")
  },
  {
    name: "example___zh",
    path: "/zh/example",
    component: () => import("/src/pages/example.vue")
  },
  {
    name: "meeting___en",
    path: "/en/meeting",
    meta: meetingSSpgQPFzofznlNAgHI0x_6_Um_zuhKibXYD_45j_45yiPsAMeta || {},
    component: () => import("/src/pages/meeting.vue")
  },
  {
    name: "meeting___zh",
    path: "/zh/meeting",
    meta: meetingSSpgQPFzofznlNAgHI0x_6_Um_zuhKibXYD_45j_45yiPsAMeta || {},
    component: () => import("/src/pages/meeting.vue")
  },
  {
    name: "recruit___en",
    path: "/en/recruit",
    component: () => import("/src/pages/recruit.vue")
  },
  {
    name: "recruit___zh",
    path: "/zh/recruit",
    component: () => import("/src/pages/recruit.vue")
  },
  {
    name: "my-asset___en",
    path: "/en/my/asset",
    meta: asset_4EOH2ID2MVMsR4Kkah5dgsg7DjtCnARU0O8I78CA54Meta || {},
    component: () => import("/src/pages/my/asset.vue")
  },
  {
    name: "my-asset___zh",
    path: "/zh/my/asset",
    meta: asset_4EOH2ID2MVMsR4Kkah5dgsg7DjtCnARU0O8I78CA54Meta || {},
    component: () => import("/src/pages/my/asset.vue")
  },
  {
    name: "my-charge___en",
    path: "/en/my/charge",
    meta: chargebgQqbuw2yDiYAYkq8JmOPGmyRKZNco_Sep9BLr7GnEsMeta || {},
    component: () => import("/src/pages/my/charge.vue")
  },
  {
    name: "my-charge___zh",
    path: "/zh/my/charge",
    meta: chargebgQqbuw2yDiYAYkq8JmOPGmyRKZNco_Sep9BLr7GnEsMeta || {},
    component: () => import("/src/pages/my/charge.vue")
  },
  {
    name: "funds-id___en",
    path: "/en/funds/:id()",
    meta: _91id_93aVRSqzrJ8byyKSneuolDlsoAaJf2SP7KR_S2D_45RkgkYMeta || {},
    component: () => import("/src/pages/funds/[id].vue")
  },
  {
    name: "funds-id___zh",
    path: "/zh/funds/:id()",
    meta: _91id_93aVRSqzrJ8byyKSneuolDlsoAaJf2SP7KR_S2D_45RkgkYMeta || {},
    component: () => import("/src/pages/funds/[id].vue")
  },
  {
    name: "my-clients___en",
    path: "/en/my/clients",
    meta: clientseaK42iqk2Bcsax68V0gBtRyh4XYUCf1MpbpX7AXSt1EMeta || {},
    component: () => import("/src/pages/my/clients.vue")
  },
  {
    name: "my-clients___zh",
    path: "/zh/my/clients",
    meta: clientseaK42iqk2Bcsax68V0gBtRyh4XYUCf1MpbpX7AXSt1EMeta || {},
    component: () => import("/src/pages/my/clients.vue")
  },
  {
    name: "my-history___en",
    path: "/en/my/history",
    meta: historyanIsx3ejdIDyAYUNOsWSiSPO2OJS4vku_rzW9igNfGEMeta || {},
    component: () => import("/src/pages/my/history.vue")
  },
  {
    name: "my-history___zh",
    path: "/zh/my/history",
    meta: historyanIsx3ejdIDyAYUNOsWSiSPO2OJS4vku_rzW9igNfGEMeta || {},
    component: () => import("/src/pages/my/history.vue")
  },
  {
    name: "admin___en",
    path: "/en/admin",
    meta: indexn2s7p5m3f2IvTsOutjwrZistLUury3_45ZZ55qWn9C9MkMeta || {},
    component: () => import("/src/pages/admin/index.vue")
  },
  {
    name: "admin___zh",
    path: "/zh/admin",
    meta: indexn2s7p5m3f2IvTsOutjwrZistLUury3_45ZZ55qWn9C9MkMeta || {},
    component: () => import("/src/pages/admin/index.vue")
  },
  {
    name: "funds___en",
    path: "/en/funds",
    meta: indexmG_45tCTh9qbvo0FyKBpvOUf1eaiQd3T4jhnyZLNZzK7QMeta || {},
    component: () => import("/src/pages/funds/index.vue")
  },
  {
    name: "funds___zh",
    path: "/zh/funds",
    meta: indexmG_45tCTh9qbvo0FyKBpvOUf1eaiQd3T4jhnyZLNZzK7QMeta || {},
    component: () => import("/src/pages/funds/index.vue")
  },
  {
    name: "announcement___en",
    path: "/en/announcement",
    meta: announcementSIHBP945_ayZk6qWTlB_GlLZBw4p08TuoXyuD_45Sh_45roMeta || {},
    component: () => import("/src/pages/announcement.vue")
  },
  {
    name: "announcement___zh",
    path: "/zh/announcement",
    meta: announcementSIHBP945_ayZk6qWTlB_GlLZBw4p08TuoXyuD_45Sh_45roMeta || {},
    component: () => import("/src/pages/announcement.vue")
  },
  {
    name: "demo-chatbot___en",
    path: "/en/demo/chatbot",
    component: () => import("/src/pages/demo/chatbot.vue")
  },
  {
    name: "demo-chatbot___zh",
    path: "/zh/demo/chatbot",
    component: () => import("/src/pages/demo/chatbot.vue")
  },
  {
    name: "comments-id___en",
    path: "/en/comments/:id()",
    component: () => import("/src/pages/comments/[id].vue")
  },
  {
    name: "comments-id___zh",
    path: "/zh/comments/:id()",
    component: () => import("/src/pages/comments/[id].vue")
  },
  {
    name: "member-passwd___en",
    path: "/en/member/passwd",
    meta: passwdbbtEZossInGMWpGdIbeRRVgNYT1AC8RaH1MibNBQiHUMeta || {},
    component: () => import("/src/pages/member/passwd.vue")
  },
  {
    name: "member-passwd___zh",
    path: "/zh/member/passwd",
    meta: passwdbbtEZossInGMWpGdIbeRRVgNYT1AC8RaH1MibNBQiHUMeta || {},
    component: () => import("/src/pages/member/passwd.vue")
  },
  {
    name: "member-signin___en",
    path: "/en/member/signin",
    meta: signin3aa_45AHf19K2hjCT_45Tu00knih7cI5JKQyruPgrc3zjRUMeta || {},
    component: () => import("/src/pages/member/signin.vue")
  },
  {
    name: "member-signin___zh",
    path: "/zh/member/signin",
    meta: signin3aa_45AHf19K2hjCT_45Tu00knih7cI5JKQyruPgrc3zjRUMeta || {},
    component: () => import("/src/pages/member/signin.vue")
  },
  {
    name: "member-signup___en",
    path: "/en/member/signup",
    meta: signupodiHZdUYeOomueJ30WSChxLvAFpLBNflRo7MqjZZhX8Meta || {},
    component: () => import("/src/pages/member/signup.vue")
  },
  {
    name: "member-signup___zh",
    path: "/zh/member/signup",
    meta: signupodiHZdUYeOomueJ30WSChxLvAFpLBNflRo7MqjZZhX8Meta || {},
    component: () => import("/src/pages/member/signup.vue")
  },
  {
    name: "comments___en",
    path: "/en/comments",
    meta: indexM2txBwHfcIeA5g_pWFuvwmiPhs9GUyOP5Hsu3GWc_45OQMeta || {},
    component: () => import("/src/pages/comments/index.vue")
  },
  {
    name: "comments___zh",
    path: "/zh/comments",
    meta: indexM2txBwHfcIeA5g_pWFuvwmiPhs9GUyOP5Hsu3GWc_45OQMeta || {},
    component: () => import("/src/pages/comments/index.vue")
  },
  {
    name: "events-2023vip___en",
    path: "/en/events/2023vip",
    meta: _2023vipxDbYIFeqjfDpBzRadu1jnwwG6aPQ2urc03O2P0Oq3osMeta || {},
    component: () => import("/src/pages/events/2023vip.vue")
  },
  {
    name: "events-2023vip___zh",
    path: "/zh/events/2023vip",
    meta: _2023vipxDbYIFeqjfDpBzRadu1jnwwG6aPQ2urc03O2P0Oq3osMeta || {},
    component: () => import("/src/pages/events/2023vip.vue")
  },
  {
    name: "my-notify-id___en",
    path: "/en/my/notify-:id()",
    meta: notify_45_91id_93Y5ibbBzvc_ulAmTyqPgZ8keG_0bMRaS3C6lT1izihdkMeta || {},
    component: () => import("/src/pages/my/notify-[id].vue")
  },
  {
    name: "my-notify-id___zh",
    path: "/zh/my/notify-:id()",
    meta: notify_45_91id_93Y5ibbBzvc_ulAmTyqPgZ8keG_0bMRaS3C6lT1izihdkMeta || {},
    component: () => import("/src/pages/my/notify-[id].vue")
  },
  {
    name: "manage-type___en",
    path: "/en/manage/:type?",
    meta: _91_91type_93_932Nu6NCDyg0eH0Zrx0SO3kWmOuQR_45XiHsceUV3R2xIpUMeta || {},
    component: () => import("/src/pages/manage/[[type]].vue")
  },
  {
    name: "manage-type___zh",
    path: "/zh/manage/:type?",
    meta: _91_91type_93_932Nu6NCDyg0eH0Zrx0SO3kWmOuQR_45XiHsceUV3R2xIpUMeta || {},
    component: () => import("/src/pages/manage/[[type]].vue")
  },
  {
    name: "admin-accounts-w8___en",
    path: "/en/admin/accounts/w8",
    meta: w89BJg17aZQU426C89PtZGhzx3dVoAoeNCDBtjFqStp14Meta || {},
    component: () => import("/src/pages/admin/accounts/w8.vue")
  },
  {
    name: "admin-accounts-w8___zh",
    path: "/zh/admin/accounts/w8",
    meta: w89BJg17aZQU426C89PtZGhzx3dVoAoeNCDBtjFqStp14Meta || {},
    component: () => import("/src/pages/admin/accounts/w8.vue")
  },
  {
    name: "my-notify-tab___en",
    path: "/en/my/notify/:tab?",
    meta: _91_91tab_93_93mcRZS7sWDY3SHBcFYZumtDVzBaQL5rjZkNauc_45Rj8_wMeta || {},
    component: () => import("/src/pages/my/notify/[[tab]].vue")
  },
  {
    name: "my-notify-tab___zh",
    path: "/zh/my/notify/:tab?",
    meta: _91_91tab_93_93mcRZS7sWDY3SHBcFYZumtDVzBaQL5rjZkNauc_45Rj8_wMeta || {},
    component: () => import("/src/pages/my/notify/[[tab]].vue")
  },
  {
    name: "member-forget___en",
    path: "/en/member/forget",
    meta: indexpe3SBrJU0yB0xlFjhmF8FuxzRci_45_1i62bT4gSY934IMeta || {},
    component: () => import("/src/pages/member/forget/index.vue")
  },
  {
    name: "member-forget___zh",
    path: "/zh/member/forget",
    meta: indexpe3SBrJU0yB0xlFjhmF8FuxzRci_45_1i62bT4gSY934IMeta || {},
    component: () => import("/src/pages/member/forget/index.vue")
  },
  {
    name: "my-dealing-type___en",
    path: "/en/my/dealing/:type?",
    meta: _91_91type_93_93z8qQBHy0rnDch_45WzcNAghwGR_lzbOwN1TWBBJ7xuGIYMeta || {},
    component: () => import("/src/pages/my/dealing/[[type]].vue")
  },
  {
    name: "my-dealing-type___zh",
    path: "/zh/my/dealing/:type?",
    meta: _91_91type_93_93z8qQBHy0rnDch_45WzcNAghwGR_lzbOwN1TWBBJ7xuGIYMeta || {},
    component: () => import("/src/pages/my/dealing/[[type]].vue")
  },
  {
    name: "sub-accounts-tab___en",
    path: "/en/sub-accounts/:tab?",
    meta: _91_91tab_93_93Cr_fyi9z3oJgsXeSiccJgnY_fW_JAMFdgp6Kn1ZlrHAMeta || {},
    component: () => import("/src/pages/sub-accounts/[[tab]].vue")
  },
  {
    name: "sub-accounts-tab___zh",
    path: "/zh/sub-accounts/:tab?",
    meta: _91_91tab_93_93Cr_fyi9z3oJgsXeSiccJgnY_fW_JAMFdgp6Kn1ZlrHAMeta || {},
    component: () => import("/src/pages/sub-accounts/[[tab]].vue")
  },
  {
    name: "admin-reports-browse___en",
    path: "/en/admin/reports/browse",
    meta: indexqi1oxHE815T7oYwetwpE2d8i2X_451hbUmfD0JN8UVbdsMeta || {},
    component: () => import("/src/pages/admin/reports/browse/index.vue")
  },
  {
    name: "admin-reports-browse___zh",
    path: "/zh/admin/reports/browse",
    meta: indexqi1oxHE815T7oYwetwpE2d8i2X_451hbUmfD0JN8UVbdsMeta || {},
    component: () => import("/src/pages/admin/reports/browse/index.vue")
  },
  {
    name: "admin-reports-edit-slug___en",
    path: "/en/admin/reports/edit/:slug(.*)*",
    meta: _91_46_46_46slug_93RLv_45WWohblgeIDlpRlTRi0ma_45_KXleRPmEa_ITk5S5MMeta || {},
    component: () => import("/src/pages/admin/reports/edit/[...slug].vue")
  },
  {
    name: "admin-reports-edit-slug___zh",
    path: "/zh/admin/reports/edit/:slug(.*)*",
    meta: _91_46_46_46slug_93RLv_45WWohblgeIDlpRlTRi0ma_45_KXleRPmEa_ITk5S5MMeta || {},
    component: () => import("/src/pages/admin/reports/edit/[...slug].vue")
  },
  {
    name: "internal-fundReport-template___en",
    path: "/en/internal/fundReport/template",
    meta: template5_034aQTYOWMdfkAm0pcQZfy1adEIyBr3Lj24xnAc8QMeta || {},
    component: () => import("/src/pages/internal/fundReport/template.vue")
  },
  {
    name: "internal-fundReport-template___zh",
    path: "/zh/internal/fundReport/template",
    meta: template5_034aQTYOWMdfkAm0pcQZfy1adEIyBr3Lj24xnAc8QMeta || {},
    component: () => import("/src/pages/internal/fundReport/template.vue")
  },
  {
    name: "admin-accounts-reference-data___en",
    path: "/en/admin/accounts/reference-data",
    meta: reference_45dataq7O12cHjyqGd7_45u__tWRmBhIK7V_45MTXJhbsRsHYc_eUMeta || {},
    component: () => import("/src/pages/admin/accounts/reference-data.vue")
  },
  {
    name: "admin-accounts-reference-data___zh",
    path: "/zh/admin/accounts/reference-data",
    meta: reference_45dataq7O12cHjyqGd7_45u__tWRmBhIK7V_45MTXJhbsRsHYc_eUMeta || {},
    component: () => import("/src/pages/admin/accounts/reference-data.vue")
  },
  {
    name: "admin-reports-browse-slug___en",
    path: "/en/admin/reports/browse/:slug(.*)*",
    meta: _91_46_46_46slug_93FLVXOJbuplc6FGH960HQ1A4EDKAia4j9nMcooPyQFzQMeta || {},
    component: () => import("/src/pages/admin/reports/browse/[...slug].vue")
  },
  {
    name: "admin-reports-browse-slug___zh",
    path: "/zh/admin/reports/browse/:slug(.*)*",
    meta: _91_46_46_46slug_93FLVXOJbuplc6FGH960HQ1A4EDKAia4j9nMcooPyQFzQMeta || {},
    component: () => import("/src/pages/admin/reports/browse/[...slug].vue")
  },
  {
    name: "admin-reports-limited-time___en",
    path: "/en/admin/reports/limited/:time?",
    meta: _91_91time_93_93eaVZSXGg4IBNRc1HGQyF9LLLniyxzYEKsMhc2urlmnYMeta || {},
    component: () => import("/src/pages/admin/reports/limited/[[time]].vue")
  },
  {
    name: "admin-reports-limited-time___zh",
    path: "/zh/admin/reports/limited/:time?",
    meta: _91_91time_93_93eaVZSXGg4IBNRc1HGQyF9LLLniyxzYEKsMhc2urlmnYMeta || {},
    component: () => import("/src/pages/admin/reports/limited/[[time]].vue")
  },
  {
    name: "internal-rebateReport-template___en",
    path: "/en/internal/rebateReport/template",
    meta: templatemg4Y571wVLVDTaFvSuyQRoXhoPeTmj2xIZku3fnFExwMeta || {},
    component: () => import("/src/pages/internal/rebateReport/template.vue")
  },
  {
    name: "internal-rebateReport-template___zh",
    path: "/zh/internal/rebateReport/template",
    meta: templatemg4Y571wVLVDTaFvSuyQRoXhoPeTmj2xIZku3fnFExwMeta || {},
    component: () => import("/src/pages/internal/rebateReport/template.vue")
  },
  {
    name: "admin-reports-preview-slug___en",
    path: "/en/admin/reports/preview/:slug(.*)*",
    meta: _91_46_46_46slug_93AzjGfzcjv_45ALQ868dyo_457gpTAvhc26PQOdzf_459GfI2wMeta || {},
    component: () => import("/src/pages/admin/reports/preview/[...slug].vue")
  },
  {
    name: "admin-reports-preview-slug___zh",
    path: "/zh/admin/reports/preview/:slug(.*)*",
    meta: _91_46_46_46slug_93AzjGfzcjv_45ALQ868dyo_457gpTAvhc26PQOdzf_459GfI2wMeta || {},
    component: () => import("/src/pages/admin/reports/preview/[...slug].vue")
  },
  {
    name: "member-forget-usercode-token___en",
    path: "/en/member/forget/:usercode()/:token()",
    meta: _91token_93nixFyM3q4wZeysE6UzE64ziAmLq6ch42mqo5GvXSAH8Meta || {},
    component: () => import("/src/pages/member/forget/[usercode]/[token].vue")
  },
  {
    name: "member-forget-usercode-token___zh",
    path: "/zh/member/forget/:usercode()/:token()",
    meta: _91token_93nixFyM3q4wZeysE6UzE64ziAmLq6ch42mqo5GvXSAH8Meta || {},
    component: () => import("/src/pages/member/forget/[usercode]/[token].vue")
  },
  {
    name: "member-otp-signin-usercode-otpCode___en",
    path: "/en/member/otp-signin/:usercode()/:otpCode()",
    meta: _91otpCode_93O0mm4pytvql_45DAMAgcI8CsHzEx5ueKJeM3QfLLUvEEAMeta || {},
    component: () => import("/src/pages/member/otp-signin/[usercode]/[otpCode].vue")
  },
  {
    name: "member-otp-signin-usercode-otpCode___zh",
    path: "/zh/member/otp-signin/:usercode()/:otpCode()",
    meta: _91otpCode_93O0mm4pytvql_45DAMAgcI8CsHzEx5ueKJeM3QfLLUvEEAMeta || {},
    component: () => import("/src/pages/member/otp-signin/[usercode]/[otpCode].vue")
  }
]